export default __webpack_public_path__ + "static/media/Roboto-Light.0cea3982.ttf";